export default __webpack_public_path__ + "static/media/Heaven Cracker Soul Sunderer.6edb35e5.jpg";